import UserCostsTable from './UserCostsTable';

export default UserCostsTable;